import React from 'react';
import {getHtmlForResolvedNodeJSON} from '../../../../../../webeditor/biokb-editor-adapters';

interface Props {
    pathEntry: PathEntryDto;
}

export function useGetEntriesHtmlContent({pathEntry}: Props) {
    const [element, setElement] = React.useState<HTMLElement | undefined>();

    React.useEffect(() => {
        let interrupted = false;
        setElement(undefined);
        const {document, expandedEditorContent, highlightedNodeIds} = pathEntry;

        getHtmlForResolvedNodeJSON(
            document.accession,
            expandedEditorContent,
            highlightedNodeIds
        ).then((el) => {
            if (interrupted) {
                return;
            }

            setElement(el);
        });

        return () => {
            interrupted = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(pathEntry)]);

    return element;
}
